import axios from "axios";
import API from "../../utils/api";
const MONDAY_API_URL = "https://api.monday.com/v2";
const MONDAY_API_KEY = "eyJhbGciOiJIUzI1NiJ9.eyJ0aWQiOjM4MDc4OTk0MywiYWFpIjoxMSwidWlkIjozOTI0NzA1MiwiaWFkIjoiMjAyNC0wNy0wNVQxMTowMDo0My4wMDBaIiwicGVyIjoibWU6d3JpdGUiLCJhY3RpZCI6MTUxMTcwNDMsInJnbiI6ImV1YzEifQ.HSSbSfeXo2bUDUZVyCujtdUO5UaDot1eUCaiV_09hC8"; // Replace with the client's key
const MONDAY_BOARD_ID = 2002376531; // Your actual board ID

export const createItemOnBoard = async ({ boardId, itemName, columnValues }) => {
   const query = `
        mutation {
            create_item(
                board_id: ${MONDAY_BOARD_ID},
                item_name: "${itemName}",
                column_values: ${JSON.stringify(JSON.stringify(columnValues))}
            ) {
                id
            }
        }
    `;

    try {
        const response = await API.post(
            MONDAY_API_URL,
            { query },
            {
                headers: {
                    Authorization: MONDAY_API_KEY,
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error sending data to Monday.com:", error.response?.data || error.message);
        throw error;
    }
};
